export default "__VITE_ASSET__1dd41154__"